import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@elotech/angular-common';
import { ProgramacaoFeriasService } from '../../../../folha-pagamento/src/programacao-ferias/programacao-ferias.service';
import { Recibo } from '../../../../folha-pagamento/src/programacao-ferias/Recibo';

@Injectable()
export class PortalProgramacaoFeriasService extends ProgramacaoFeriasService {

  private readonly resourcePortal: string = '/api/portal-servidor/programacao-ferias';

  constructor(httpClient: HttpClient) {
    super(httpClient);
  }

  public findReciboProgramacaoFerias(id: number): Observable<Recibo> {
    return this.httpClient.get({
      resource: `${this.resourcePortal}/recibo/${id}`
    });
  }

  public findPeriodoProgramacaoFerias(idProgramacaoFerias: number): Observable<Partial<Recibo>> {
    return this.httpClient.get({
      resource: `${this.resourcePortal}/periodo-recibo/${idProgramacaoFerias}`
    });
  }
}
